<template>
  <div class="courseDetail">
    <van-nav-bar
    class="bar"
      title="视频详情"
      left-text="返回"
      left-arrow
      @click-left="back"
    />
    <div class="banner" >
      <img :src="this.$store.state.ip+data.v_img" alt v-show="!showVideo"  />
      <div class="loading_box">
        <van-progress pivot-text="橙色" color="#f2826a" :percentage="25" v-if="loading.movie === 'loading'" />
      </div>
      <div v-show="showVideo" >
        <div class="video_box" ref="Dplayer_dom" style="width: 100%;height: 100%"></div>  
      </div>
      
      <div class="banner-info" v-show="!showVideo">
        <div class="info">
          <div class="name">{{data.v_name}}</div>
          <div class="rate">
            <span>K{{data.v_strong}}</span>
            <van-rate
              v-model="data.v_strong"
              icon="fire"
              :size="16"
              color="#fff"
              void-icon="fire"
              void-color="#96959B"
              readonly
            />
            
          </div>
          
        </div>
      </div>
    </div>
    <div class="course-info" v-show="!showVideo">
      
      <div>
        <van-icon name="friends-o" />已购买人数：{{data.v_amount}}次 观看人数：{{data.v_watched}}次
      </div>
      <div>
        <van-icon name="after-sale" />{{data.v_price}}跆拳币
      </div>
    
    </div>
   
    <div class="course-des">
      <div class="title">视频介绍</div>
      <div class="description">{{data.v_description?data.v_description:'暂无'}}</div>
    </div>
    <div class="order-btn">
      <van-button v-show="!isBought&&!showVideo" type="default" @click="order">购买</van-button>
      <van-button v-show="isBought&&!showVideo" type="default" @click="changeSource(data)">观看</van-button>
    </div>
  </div>
</template>
<script>
let _self;
import { Toast } from 'vant';
import { Dialog } from 'vant';
import DPlayer from 'dplayer';
export default {
  data() {
    return {
      data:{},
      uid:'',
      loading:true,
      current_video:null,
      player: null,
      //dialog: false,
      showVideo: false,
      show_bar: false,
      isBought:false

      
    };
  },
  methods:{
    order(){
      //var uid = sessionStorage.getItem("uid");
      this.axios.post('/order/selectCourse',{  //查询是否购买过
        uid:this.uid,
        cpid:this.$route.params.id
      })
      .then(res=>{
        if(res.data.code=="200"){

          // 查询余额是否充足
          this.axios.post("/vip/getMoney",{
            id:this.uid
          })
          .then(res=>{
            console.log(res.data);
            if(res.data.code=='200'){
              var money = res.data.data;
              if(money<this.data.v_price){
                Dialog.confirm({
                  title:'余额不足',
                  message: '你的账户余额已不足 '+this.data.v_price+" 跆拳币,是否前往充值？"
                })
                .then(() => {
                  this.$router.push({path:'/home/money'});
                })
                .catch(() => {
                });
              }

              // 余额充足
              else{
                Dialog.confirm({
                  title: '确认支付',
                  message: '该操作将从你的账户中扣除 '+this.data.v_price+" 跆拳币,请确认是否继续？"
                })
                .then(()=>{
                   this.axios.post('/order/orderCourse',{
                    uid:this.uid,
                    cpid:this.$route.params.id,
                    c_name:this.data.v_name
                  })
                  .then(res=>{
                    if(res.data.code=='200'){

                      // 扣取费用
                      this.axios.post('/vip/income',{
                        id:this.uid,
                        money:Number("-"+this.data.v_price),
                        msg:"视频购买",
                      })
                      .then(res=>{
                        console.log(res.data);
                        if(res.data.code=='200'){
                          Toast.success("购买成功！");
                          this.isBought=true
                          this.$router.push({path:'/home/courseHistory'});
                        }
                      })
                    }
                    else{
                      Toast.fail(res.data.msg);
                      
                    }
                  })
                })
                 
              }

            }
          })
        }
        else{
          Toast.fail("你已经购买过该课程了！");
        }
      })
    },
    back(){
      this.$router.go(-1);
    },
    closeVideo() {
      this.showVideo = false
    },
   
    // 初始化视频播放器
    initDplayer() {  
      let Dplayer_dom = _self.$refs.Dplayer_dom;
      _self.player = new DPlayer({
        element: Dplayer_dom,
        video: {
          url: _self.$store.state.ip+_self.current_video.v_url,
          // pic: _self.movie.cover,
          autoplay: true,
          lang: 'zh',
          screenshot: true,
          hotkey: true,
          preload: 'auto',
        },
        
        // 加载弹幕
        // danmaku: {
        //     id: '1',
        //     api: 'https://api.prprpr.me/dplayer/'
        // },
        contextmenu: [{
          text: '版本: v1.5.0',
          link: 'https://github.com/MoePlayer/DPlayer/releases'
        }, {
          text: 'HTML5视频播放器',
          link: 'https://github.com/DIYgod/DPlayer'
        }]
      });
     
        // console.log(this.player.video);
var c_video=this.player.video;
c_video.addEventListener("timeupdate",function(){  
var timeDisplay;
      //用秒数来显示当前播放进度
timeDisplay = Math.floor(c_video.currentTime)     
if(timeDisplay==3&&_self.data.v_price!=0){
  if(!_self.isBought){
           c_video.webkitExitFullScreen();
           _self.showVideo=false;
           c_video.pause();
           timeDisplay=0;
           Dialog.confirm({
                  title:'该视频需要付费',
                  message: " 是否购买该视频？"
                })
                  .then(()=>{
                    //console.log(_self.uid)
                  if(_self.uid&&_self.uid!=''){  
                     //console.log(_self.uid)                  
                   _self.axios.post('/order/orderCourse',{
                    uid:_self.uid,
                    cpid:_self.$route.params.id,
                    c_name:_self.data.v_name
                  })
                  .then(res=>{
                    if(res.data.code=='200'){

                      // 扣取费用
                      _self.axios.post('/vip/income',{
                        id:_self.uid,
                        money:Number("-"+_self.data.v_price),
                        msg:"视频购买",
                      })
                      .then(res=>{
                        console.log(res.data);
                        if(res.data.code=='200'){
                          Toast.success("购买成功！");
                          _self.$router.push({path:'/home/courseHistory'});
                        }
                      })
                    }
                    else{
                      Toast.fail(res.data.msg);
                    }
                  })
                  }else{
                   _self.$router.push({path:'/login'}); 
                  }
                })
                .catch(() => {
                });
        }
        }
        }) 
    },
    changeSource(video) {
      this.showVideo = true;
      this.current_video = video;
      this.initDplayer();
      this.player.video.play(); 
      },  
    showTeacher(){
      this.$router.push("/home/teacherDetail/"+this.data.t_id);
    },
    switchTimeFormat(date) {
      var dateTime = new Date(date);
      var month = dateTime.getMonth() + 1;
      var day = dateTime.getDate();
      var hour = dateTime.getHours();
      month = month>9?month:'0'+month;
      day = day>9?day:'0'+day;
      hour = hour>9?hour:'0'+hour;
      var time  = month+"月"+day+"日 "+hour+":00-"+hour+":50"
      return time;
    },
  },
  created(){
    _self = this;   
    Toast.loading({
      overlay:true,
      duration:0,
      message: '加载中...',
      forbidClick: true,
    });
    
    this.axios.post("/course/getPlanDetail", {
      id:this.$route.params.id
    })
    .then((res) => {
      //console.log(res);
      if(res.data.code=='200'){
        this.loading=false;
        this.data = res.data.data;
        Toast.clear();
        this.changeSource(this.data)
      }
    })
    .catch(err=> {
      console.log(err)
    })
    _self.uid= sessionStorage.getItem("uid");
    if (_self.uid&&_self.uid!='') {
       this.axios.post('/order/selectCourse',{  //查询是否购买过
        uid:this.uid,
        cpid:this.$route.params.id
      })
      .then(res=>{
        if(res.data.code!="200"){
          this.isBought=true;
        }
      })
    }
     
  }
  
};
</script>
<style lang="less" scoped>
@import "../assets/less/base.less";
.van-nav-bar__text,.van-nav-bar .van-icon{
  color: @buttonColor;
}
.courseDetail {
  min-height: 667px;
  padding-bottom: 50px;
  background: @lineColor;
}
.banner {
  width: 100%;
  height: 240px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
  .banner-info {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    .info {
      background-image: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0.4) 0%,
        rgba(0, 0, 0, 0.2) 25%,
        rgba(0, 0, 0, 0.2) 75%,
        rgba(0, 0, 0, 0.4) 100%
      );
      padding: 10px;
      .name {
        font-size: 20px;
        font-weight: bold;
        padding: 5px;
      }
      .rate {
        font-size: 16px;
        vertical-align: top;
        line-height: 20px;
        height: 20px;
        padding: 5px;

        .van-rate {
          line-height: 20px;
          vertical-align: middle;
          height: 20px;
        }
      }
    }
  }
}
.course-info {
  padding: 10px;
  background: #fff;
  .location {
    border-top: 1px solid @lineColor;
    margin-top: 10px;
    padding-top: 10px;
    .phone {
      margin: 5px 0;
      padding: 0  10px;
      display: inline-block;
      color: @mainColor;
      float: right;
      height: 20px;
      border-left: 1px solid @lineColor;
      .van-icon {
        line-height: 20px;
        height: 20px;
        // padding: 5px;
      }
    }
  }
  div {
    padding: 5px;
    line-height: 30px;
    height: 30px;
    vertical-align: top;
  }
  .van-icon {
    height: 30px;
    line-height: 30px;
    font-size: 18px;
    vertical-align: top;
  }
}
.teacher {
  padding: 0 15px;
  margin-top: 10px;
  background: #fff;
  .title {
    padding: 10px 0;
    border-bottom: 1px solid @lineColor;
  }
  .teacher-main {
    padding: 10px 0;
    & > div {
      float: left;
    }

    .avtor {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      overflow: hidden;
      img {
        width: 100%;
      }
    }
  .loading_box {
    text-align: center;
    padding-top: 40px;
  }
    .teacher-info {
      padding-left: 5px;
      width: 185px;
      height: 80px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      i {
        vertical-align: middle;
      }
    }
  }
}
.course-des {
  padding: 0 15px;
  margin-top: 10px;
  background: white;
  .title {
    padding: 10px 0;
    border-bottom: 1px solid @lineColor;
  }
  .description {
    padding: 10px 0;
  }
}
.order-btn {
  margin-top: 10px;
  button {
    border: none;
    background: @buttonColor;
    width: 100%;
    color: white;
  }
}

</style>